module.exports = __webpack_public_path__ + "img/FR31489.ce4e3e20.png";